import { render, staticRenderFns } from "./GiftGuideSlideGroup.vue?vue&type=template&id=1dcdfa79&scoped=true"
import script from "./GiftGuideSlideGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./GiftGuideSlideGroup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GiftGuideSlideGroup.vue?vue&type=style&index=0&id=1dcdfa79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcdfa79",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatorShopLink: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/CreatorShopLink.vue').default,CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CreatorShopGiftGuideTile: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/gift-guides/GiftGuideTile.vue').default,CSlideItem: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSlideGroup/CSlideItem.vue').default,CLtkSlideGroup: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkSlideGroup/CLtkSlideGroup.vue').default})
